import { render } from "./ProgramDrugTestReport.vue?vue&type=template&id=624ef49d&ts=true"
import script from "./ProgramDrugTestReport.vue?vue&type=script&lang=ts"
export * from "./ProgramDrugTestReport.vue?vue&type=script&lang=ts"

import "./ProgramDrugTestReport.vue?vue&type=style&index=0&id=624ef49d&lang=css"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__